import React, {Component} from 'react';
import {Container, Header} from 'semantic-ui-react'
import Work from './Work';

export default class WorkExperience extends Component {
  render() {
    return (
    	<Container>
    		<Header as='h2'>Employment History</Header>
    		{/*<Segment style={{padding: 0}}>*/}
			{/*	<Map locations={workLocations} map={{projectionConfig: {scale: 220, xOffset: -50, yOffset: 10,}, width: 980, height: 450}}/></Segment>*/}
			<Work
				title="ThoughtWorks"
				link="https://www.thoughtworks.com"
				position="Software Consultant"
				startDate="01/2017"
				locations={['Brisbane, Australia', 'Canberra, Australia', 'Melbourne, Australia', 'Pune, India', 'Barcelona, Spain']}
			/>
			<Work 
				title="Queensland University of Technology"
				link="https://www.qut.edu.au/"
				position="ITAS Tutor"
				startDate="02/2014"
				endDate="06/2014"
				locations={['Brisbane, Australia']}
			/>
			<Work 
				title="The Passionist Youth Retreat Team"
				link="https://www.passionistyouth.com.au/"
				position="Retreat Facilitator"
				startDate="01/2012"
				endDate="12/2015"
				locations={['Brisbane, Australia']}
			/>
		</Container>
    );
  }
}


